<template>
  <div class="container maxWidth-sm">
    <div class="row">
      <h1>Develop Data Export</h1>
    </div>
    <hr />
    <div class="row">
      <div class="col-sm-9">
        <p>
          Choose the dates for which you wish to download data. Only Develop plans
          <b>started</b> within these dates (inclusive) will be included.
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-9">
        <p>
          <small>
            (Examples:
            <a href="javascript:void(0)" @click="pickSevenDays">Last 7 days</a>,
            <a href="javascript:void(0)" @click="pickPastThirtyDays">Last 30 days</a>,
            <a href="javascript:void(0)" @click="pickPastThreeMonths">Last 3 months</a>,
            <a href="javascript:void(0)" @click="pickPastSixMonths">Last 6 months</a>,
            <a href="javascript:void(0)" @click="pickPastYear">Last year</a>,
            <a href="javascript:void(0)" @click="pickYearToDate">Year to date</a>)
          </small>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-10 col-sm-offset-1 text-big">
        <div class="form-group">
          <label class="control-label" for="earliest">Earliest start:</label>
          <input
            type="date"
            class="form-control"
            id="fromDatetime"
            v-model="earliest"
            autocomplete="off"
          />
          <br />
          <label class="control-label" for="latest">Latest start:</label>
          <input type="date" class="form-control" id="latest" v-model="latest" autocomplete="off" />
        </div>
        <hr />
        <div class="form-group">
          <button
            class="btn btn-lg btn-primary"
            @click="download"
            :disabled="!isValid"
            style="margin-left: 10px"
          >
            Download CSV
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import moment from "dayjs";
import { computed, onMounted, ref } from "vue";

const earliest = ref<string>("");
const latest = ref<string>("");

function pickSevenDays(): void {
  earliest.value = moment().subtract(7, "day").format("YYYY-MM-DD");
  latest.value = moment().format("YYYY-MM-DD");
}

onMounted(() => {
  pickSevenDays();
});

const isValid = computed(() => {
  const earliestMoment = moment(earliest.value);
  const latestMoment = moment(latest.value);

  return (
    earliestMoment.isValid() &&
    latestMoment.isValid() &&
    latestMoment.isAfter(earliestMoment) &&
    earliestMoment.isBefore(moment())
  );
});

const downloadUrl = computed(() => {
  return `/admin/crmexport/developdata/?fromDate=${earliest.value}&toDate=${latest.value}`;
});

function download(): void {
  if (isValid.value) {
    window.location.assign(downloadUrl.value);
  }
}

function pickPastThirtyDays(): void {
  earliest.value = moment().subtract(30, "day").format("YYYY-MM-DD");
  latest.value = moment().format("YYYY-MM-DD");
}

function pickPastThreeMonths(): void {
  earliest.value = moment().subtract(3, "month").format("YYYY-MM-DD");
  latest.value = moment().format("YYYY-MM-DD");
}

function pickPastSixMonths(): void {
  earliest.value = moment().subtract(6, "month").format("YYYY-MM-DD");
  latest.value = moment().format("YYYY-MM-DD");
}

function pickPastYear(): void {
  earliest.value = moment().subtract(12, "month").format("YYYY-MM-DD");
  latest.value = moment().format("YYYY-MM-DD");
}

function pickYearToDate(): void {
  earliest.value = moment().startOf("year").format("YYYY-MM-DD");
  latest.value = moment().format("YYYY-MM-DD");
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less"></style>
